import { AdminApi } from "./AdminApi";
import type { AdminConfig } from "../models/AdminConfig";


const AdminConfigEndpoints = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminConfig: builder.query<AdminConfig, void>({
      query: () => {
        return {
          url: "config",
          method: "GET"
        };
      },
    }),
  }),
});

export const {
  useGetAdminConfigQuery,
} = AdminConfigEndpoints;
